import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { BusinessPartnerPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ContactpersonCreateModel {
    businessPartnerId: number
    name: string
    department?: string
    genderId?: number
    phone?: string
    email?: string
}

const AddContactpersonPopup: React.FC<BusinessPartnerPopupProps> = ({ show, onHide, businessPartnerId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ContactpersonCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ContactpersonCreateModel>({
        businessPartnerId: businessPartnerId,
        name: '',
    });

    const genders = useSelectListOptions('api/v1/selectlist/Genders', '-- Select gender');

    function submit() {
        if (formData) {
            DataService
                .create<ContactpersonCreateModel>(`api/v1/Contactpersons`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'department', label: 'Department', labelSize: 4 },
            { name: 'genderId', label: 'Gender', labelSize: 4 },
            { name: 'phone', label: 'Phone', labelSize: 4 },
            { name: 'email', label: 'Email', labelSize: 4 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add contactperson'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <TextboxField {...getFieldProps('department')} />
                <SelectListField {...getFieldProps('genderId')} options={genders} />
                <TextboxField {...getFieldProps('phone')} />
                <TextboxField {...getFieldProps('email')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddContactpersonPopup;